const config = {
    appVersion: '2023-02-7508',
    serverUrl: '',
    proxyUrl: 'https://endpoints.azure.hycu.com/',
    registryUrl: 'https://registry.azure.hycu.com/',
    clientId: '88aa6126-8fc3-4c64-b0e3-8ec5ceec0b2e',
    stateResource: 'STATE_RESOURCE',
    registrationRedirectUrl: 'REGISTRATION_REDIRECT_URL',
    jsonServerUrl: 'http://localhost:8081',
    docs: {
        url: 'https://docs.azure.hycu.com',
        query: 'cshid'
    },
    langFiles: ['gui_backup_lang', 'shared_lang'],
    dateFormats: { // moment.js date formats
        short: { date: 'l', datetime: 'l LT' },
        shortSec: { date: 'l', datetime: 'l LTS' },
        medium: { date: 'll', datetime: 'll LT' },
        long: { date: 'LL', datetime: 'LL LTS' },
        full: { date: 'LLL', datetime: 'LL LTS' }
    },
    locale: detectLocale(),
    timezone: detectTimezone()
};

function detectLocale() {
    return 'en';
}

function detectTimezone() {
    return moment.tz.guess();
}

module.exports = config;



// WEBPACK FOOTER //
// ./src/azurebackup/app.constants.js